import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useApp } from './store/app.js';
import { BottomNav, Sidebar } from './components/Navigation.js';
import { QuickAdd } from './components/QuickAdd.js';
import { Toasts } from './components/Toasts.js';
import { Skeleton } from './components/Skeleton.js';
import { Home } from './screens/Home.js';
import { SignIn } from './screens/SignIn.js';
import { Transactions } from './screens/Transactions.js';
import { Budget } from './screens/Budget.js';
import { Goals } from './screens/Goals.js';
import { Insights } from './screens/Insights.js';
import { Profile } from './screens/Profile.js';
import { FamilyView } from './screens/FamilyView.js';
import { CoupleView } from './screens/CoupleView.js';

export default function App() {
  const { ready, authenticated, boot } = useApp();

  useEffect(() => { void boot(); }, [boot]);

  if (!ready) {
    return (
      <div className="screen stack" style={{ paddingTop: 'var(--sp-8)' }}>
        <Skeleton height={200} radius={20} />
        <Skeleton height={120} radius={16} />
        <span className="sr-only">טוען…</span>
      </div>
    );
  }

  if (!authenticated) return <SignIn />;

  return (
    <BrowserRouter>
      <div className="app">
        <Sidebar />
        <div className="grow" style={{ minWidth: 0 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/budget" element={<Budget />} />
            <Route path="/goals" element={<Goals />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/family" element={<FamilyView />} />
            <Route path="/couple" element={<CoupleView />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
        <BottomNav />
        <QuickAdd />
        <Toasts />
      </div>
    </BrowserRouter>
  );
}
